var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"close-text":"Close Alert","type":"error","dismissible":"","width":_vm.$attrs.width ? _vm.$attrs.width : '100%'},on:{"input":_vm.onClose}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }